import CashHero404 from './../views/errors/CashHero404'

export const errorsRouter = {
  path: '*',
  name: 'errors',
  component: CashHero404
}
